"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelDashed = void 0;
var React = require("react");
var PanelDashed = /** @class */ (function (_super) {
    __extends(PanelDashed, _super);
    function PanelDashed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PanelDashed.prototype.render = function () {
        return (React.createElement("div", { className: "shadow panel-dashed ".concat(this.props.className) },
            React.createElement("div", { className: "panel-dashed-inner" }, this.props.children)));
    };
    return PanelDashed;
}(React.Component));
exports.PanelDashed = PanelDashed;
//# sourceMappingURL=PanelDashed.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/components/PanelDashed.js
// module id = 3463
// module chunks = 0